import { Component } from '@angular/core';

@Component({
    selector: 'audio-template',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class AudioTemplateComponent {}
